import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams, Link } from "react-router-dom";
import authApi from "services/authService";

const VerifyEmail = () => {
 const { t } = useTranslation();
 const [searchParams] = useSearchParams();
 const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
 const [message, setMessage] = useState("");

 useEffect(() => {
  const verify = async () => {
   const token = searchParams.get("token");
   if (!token) {
    setStatus("error");
    setMessage("Invalid verification link. No token provided.");
    return;
   }

   try {
    await authApi.verifyEmail(token);
    setStatus("success");
    setMessage("Email successfully verified! You can now log in.");
   } catch (error: any) {
    setStatus("error");
    setMessage(
     error?.response?.data?.error ||
      error?.response?.data?.message ||
      "Failed to verify email. The link may have expired or is invalid."
    );
   }
  };

  verify();
 }, [searchParams]);

 return (
  <div
   className="flex items-center justify-center min-h-screen"
   style={{
    background: "linear-gradient(135deg, #F5F1ED 0%, #EBE5DE 100%)",
   }}
  >
   <div className="w-full max-w-md">
    {/* Header */}
    <div className="text-center mb-8">
     <h1 className="text-4xl font-bold text-store-primary mb-2 font-store">
      {t("common.appName")}
     </h1>
     <p className="text-store-accent text-sm tracking-widest">
      EMPOWER YOUR COMMERCE
     </p>
    </div>

    {/* Status Card */}
    <div className="bg-white  overflow-hidden border-store-accent">
     <div className="p-8 space-y-6">
      <div>
       <h2 className="text-2xl font-bold text-store-primary mb-1">
        Email Verification
       </h2>
      </div>

      {status === "loading" && (
       <div className="text-center py-8">
        <div className="inline-block animate-spin h-12 w-12 border-t-2 border-b-2 border-store-accent"></div>
        <p className="mt-4 text-store-text">Verifying your email...</p>
       </div>
      )}

      {status === "success" && (
       <div className="space-y-4">
        <div className="bg-green-50 border border-green-200 p-4">
         <div className="flex items-center">
          <svg
           className="w-6 h-6 text-green-600 mr-2"
           fill="none"
           stroke="currentColor"
           viewBox="0 0 24 24"
          >
           <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
           />
          </svg>
          <p className="text-green-700 text-sm font-medium">{message}</p>
         </div>
        </div>
        <Link
         to="/login"
         className="block w-full bg-store-primary text-white font-semibold py-3 hover:opacity-90 transition-all text-center"
        >
         Go to Login
        </Link>
       </div>
      )}

      {status === "error" && (
       <div className="space-y-4">
        <div className="bg-red-50 border border-red-200 p-4">
         <div className="flex items-center">
          <svg
           className="w-6 h-6 text-red-600 mr-2"
           fill="none"
           stroke="currentColor"
           viewBox="0 0 24 24"
          >
           <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
           />
          </svg>
          <p className="text-red-700 text-sm font-medium">{message}</p>
         </div>
        </div>
        <div className="flex gap-4">
         <Link
          to="/login"
          className="flex-1 bg-store-primary text-white font-semibold py-3 hover:opacity-90 transition-all text-center"
         >
          Go to Login
         </Link>
         <Link
          to="/register"
          className="flex-1 bg-store-secondary text-store-primary font-semibold py-3 hover:opacity-90 transition-all text-center"
         >
          Register
         </Link>
        </div>
       </div>
      )}
     </div>
    </div>
   </div>
  </div>
 );
};

export default VerifyEmail;





